import Event from "../event";
import {MAX_DURATION_DAYS} from "./set-calendar-duration";


export default function eventSetWorkdayDuration(event:Event, value:number | null) {

    if (_.isNaN(value) || !String(value).trim() || value === null) value = 0;

    if (value === 0) {
        // event.updateStartDate(null)
        return;
    }

    if (event.isSingleDayType) value = 1 // patch

    if (value > MAX_DURATION_DAYS) value = MAX_DURATION_DAYS

    const startDate     = event.startDate ? event.startDate : momentDate()
    const endDate       = event.workSchedule.calculateEndDate(startDate, value);

    event.updateStartEnd(startDate, endDate)
}
